export function getSign({
  improvement,
  isIncreaseBeneficial,
}: {
  improvement: boolean;
  isIncreaseBeneficial: boolean;
}): number {
  return isIncreaseBeneficial === improvement ? 1 : -1;
}
